import { neogtm } from './neogtmClient';

export const Signal = neogtm.entities.Signal;

export const Procurement = neogtm.entities.Deal;

export const MomentumScore = neogtm.entities.MomentumScore;

export const PersonaActivity = neogtm.entities.PersonaActivity;

export const Note = neogtm.entities.Note;

export const AccountFinal = neogtm.entities.AccountFinal;

export const PersonFinal = neogtm.entities.PersonFinal;

export const PersonaConnection = neogtm.entities.persona_connections;
export const ExternalConnection = neogtm.entities.external_connections;

export const ProcurementProfileData = neogtm.entities.ProcurementProfileData;

export const ContentProfileData = neogtm.entities.ContentProfileData;

export const IspProfileData = neogtm.entities.IspProfileData;

export const Segment = neogtm.entities.Segment;

export const Playbook = neogtm.entities.Playbook;

export const Deal = neogtm.entities.Deal;

/** Closed awards from closed_deals table (Supabase) */
export const ClosedDeal = neogtm.entities.ClosedDeal;

export const Alert = neogtm.entities.Alert;

export const AlertPreference = neogtm.entities.AlertPreference;

export const Department = neogtm.entities.Department;

export const UserSession = neogtm.entities.UserSession;



// auth sdk - using backend API
export const User = neogtm.auth;